var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading-container"},[(_vm.type >=1)?_c('h2',{staticClass:"primary-title"},[_vm._t("primary-title")],2):_vm._e(),(_vm.type >=1)?_c('h3',{staticClass:"secondary-title"},[_vm._t("secondary-title")],2):_vm._e(),(_vm.type >=2)?_c('p',{staticClass:"info-text"},[_vm._t("info-text")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }